import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/editors/check_box/check_box.j.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../../core/component_registrator";
import BaseComponent from "../../../component_wrapper/editors/check_box";
import { CheckBox as CheckBoxComponent, defaultOptions } from "./check_box";

var CheckBox =
/*#__PURE__*/
function (_BaseComponent) {
  _inherits(CheckBox, _BaseComponent);

  function CheckBox() {
    _classCallCheck(this, CheckBox);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckBox).apply(this, arguments));
  }

  _createClass(CheckBox, [{
    key: "getProps",
    value: function getProps() {
      var props = _get(_getPrototypeOf(CheckBox.prototype), "getProps", this).call(this);

      props.onKeyDown = this._wrapKeyDownHandler(props.onKeyDown);
      return props;
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this$viewRef3;

      var _this$viewRef;

      return null === (_this$viewRef = this.viewRef) || void 0 === _this$viewRef ? void 0 : (_this$viewRef3 = _this$viewRef).focus.apply(_this$viewRef3, arguments);
    }
  }, {
    key: "blur",
    value: function blur() {
      var _this$viewRef4;

      var _this$viewRef2;

      return null === (_this$viewRef2 = this.viewRef) || void 0 === _this$viewRef2 ? void 0 : (_this$viewRef4 = _this$viewRef2).blur.apply(_this$viewRef4, arguments);
    }
  }, {
    key: "_getActionConfigs",
    value: function _getActionConfigs() {
      return {
        onFocusIn: {},
        onClick: {}
      };
    }
  }, {
    key: "_propsInfo",
    get: function get() {
      return {
        twoWay: [["value", "defaultValue", "valueChange"]],
        allowNull: ["defaultValue", "validationError", "validationErrors", "value"],
        elements: [],
        templates: [],
        props: ["text", "iconSize", "activeStateEnabled", "hoverStateEnabled", "focusStateEnabled", "saveValueChangeEvent", "defaultValue", "valueChange", "readOnly", "name", "validationError", "validationErrors", "validationMessageMode", "validationStatus", "isValid", "onFocusIn", "className", "accessKey", "disabled", "height", "hint", "onClick", "onKeyDown", "rtlEnabled", "tabIndex", "visible", "width", "aria", "value"]
      };
    }
  }, {
    key: "_viewComponent",
    get: function get() {
      return CheckBoxComponent;
    }
  }]);

  return CheckBox;
}(BaseComponent);

export { CheckBox as default };
registerComponent("dxCheckBox", CheckBox);
CheckBox.defaultOptions = defaultOptions;